import React, { useEffect, useState } from "react";
import { Alert, Chip, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";

const Subjects = ({ rowData, open, setOpen }) => {
  const { loading } = useSelector((state) => state.batch);

  return (
    <GlobalDialog
      title={"Subjects"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      content={
        <>
          {rowData.subjects?.length === 0 && (
            <Alert severity="info" variant="outlined">
              No Subjects Enrolled Yet
            </Alert>
          )}
          <Stack direction={"row"} spacing={2}>
            {rowData.subjects?.map((sub) => (
              <Chip
                key={sub.subject_id}
                label={sub.subject_name}
                variant="filled"
                color="primary"
              />
            ))}
          </Stack>
        </>
      }
    />
  );
};

export default Subjects;
